/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VoucherPaymentStatus {
  PENDING_PAYMENT = 'pending_payment',
  PAID = 'paid',
  MANUAL = 'manual',
  CONFIRMED = 'confirmed',
  CONVERTED_FROM_ORDER = 'converted_from_order',
}
